module.exports = __webpack_public_path__ + "img/Dibujo.d2f4b7fa.png";